/* eslint-disable no-param-reassign */
export default {
  state: {
    isModalOpened: false,
  },
  mutations: {
    openDetailsModal(state) {
      state.isModalOpened = true;
    },
    closeDetailsModal(state) {
      state.isModalOpened = false;
    },
  },
  getters: {
    detailsModal(state) {
      return state.isModalOpened;
    },
  },
};
